import React from 'react';
import { FaLinkedinIn, FaXTwitter, FaYoutube, FaWhatsapp } from 'react-icons/fa6';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="logo">AUTO<span className="gold">EXPERTS</span></div>
            <p>Wholesale supplier of genuine American automotive spare parts. Exporting worldwide from Dubai, UAE.</p>
          </div>
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#about">About</a></li>
              <li><a href="#brands">Brands</a></li>
              <li><a href="#why">Why Us</a></li>
              <li><a href="#markets">Markets</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              <li><a href="tel:+447774106350">+44 7774 106350</a></li>
              <li><a href="tel:+971508719109">+971 50 871 9109</a></li>
              <li><a href="mailto:ameer.94ir@gmail.com">ameer.94ir@gmail.com</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Location</h4>
            <ul>
              <li>Jebel Ali Free Zone</li>
              <li>Dubai, UAE</li>
              <li style={{ opacity: 0.4, fontSize: '13px' }}>Mon–Fri · 9:00 – 18:00</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© 2026 AUTO EXPERTS FZE. All rights reserved.</span>
          <div className="footer-socials">
            <a href="#" aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="#" aria-label="Twitter"><FaXTwitter /></a>
            <a href="#" aria-label="YouTube"><FaYoutube /></a>
            <a href="#" aria-label="WhatsApp"><FaWhatsapp /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
